module.exports = __webpack_public_path__ + "static/team-painting-3969bb397ab4f8f924a4b783de02e86b.png";